<template>
  <div class="awardItem">
    <div class="main">
      <div class="titleArea">
        <div class="label">{{ awardData.taskName }}</div>
        <div class="time">{{ awardData.rewardTime | toDayDate }}</div>
      </div>
      <div class="amountArea">
        <span class="amount">+{{ awardData.rewardAmount }}</span>
        <span class="unit"> 积分</span>
      </div>
    </div>
  </div>
</template>

<script>
import { toDayDate } from '@/components/templates/helper';
export default {
  filters: {
    toDayDate: function(val) {
      return toDayDate(val, 'yyyy.MM.dd hh:mm:ss');
    }
  },
  props: {
    awardData: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="less" scoped>
.awardItem {
  padding: 24px 30px 0px 30px;

  .main {
    padding-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;

    .label {
      font-size: 30px;
      color: #262626;
    }

    .time {
      font-size: 28px;
      color: #8c8c8c;
    }
    .amountArea {
      color: #ff6600;

      .amount {
        font-size: 42px;
        font-family: 'Alibaba Zhixing';
      }
      .unit {
        font-size: 30px;
      }
    }
  }
}
</style>
